module.exports = __webpack_public_path__ + "static/media/Rainbow-Logo.a57b7cc6.svg";